module.exports = __webpack_public_path__ + "img/9mobile_logo.d1fb351e.svg";